<script>
import { mapActions } from "vuex";
import numberMixin from "@/mixins/numberMixin";
import Wallet from "@/components/_Shared/Wallet";

function buildWithdrawPayload(professionalPGA, amount, description) {
  return {
    payer: { id: professionalPGA.id },
    receiver: { type: "bank_account", id: professionalPGA.bank_accounts[0].id },
    amount: amount.toString(),
    description
  };
}

export default {
  mixins: [numberMixin],

  components: {
    Wallet
  },

  data() {
    return {
      preloader: false,
      completedTransfer: false,
      transferResultImage: "",
      transferResultMessage: "",
      walletKeyComponent: 0
    };
  },

  props: {
    professional: {
      type: Object,
      required: true
    }
  },

  computed: {
    channelId() {
      return `transfer:${this.professional.account.id}`;
    },
    professionalPGA() {
      return this.professional.account.payment_gateway_account;
    }
  },

  methods: {
    ...mapActions("transfers", ["create"]),

    async requestWithDraw(amount) {
      this.preloader = true;

      if (this.professionalPGA.bank_accounts.length <= 0) {
        this.handleTransferSubmit(
          "/static/cancel.svg",
          "Profissional não tem conta bancária cadastrada :/",
          () => {
            this.preloader = false;
            this.completedTransfer = false;
          }
        );
      }
      try {
        let payload = buildWithdrawPayload(
          this.professionalPGA,
          amount,
          "Saque para a conta bancária"
        );
        await this.create(payload);
      } catch (error) {
        this.handleTransferSubmit("/static/cancel.svg", error[0].title, () => {
          this.preloader = false;
          this.completedTransfer = false;
        });
      }
    },

    handleTransferSubmit(image, message, func) {
      this.preloader = false;
      this.completedTransfer = true;
      this.transferResultImage = image;
      this.transferResultMessage = message;
      setTimeout(func, 2500);
    },

    subscribeToChannel() {
      this.$cable._addChannel(
        this.channelId,
        {
          received(data) {
            switch (data.data.to_state) {
              case "failed":
                this.handleTransferSubmit(
                  "/static/cancel.svg",
                  "Não foi possivel sacar o dinheiro!",
                  () => {
                    this.preloader = false;
                    this.completedTransfer = false;
                  }
                );
                break;

              case "requested":
                this.handleTransferSubmit(
                  "/static/wallet-withdraw.svg",
                  "Saque para a conta bancária foi solicitado!",
                  () => {
                    this.completedTransfer = false;
                    this.walletKeyComponent += 1;
                    this.$emit("refresh");
                  }
                );

              case "completed":
                this.handleTransferSubmit(
                  "/static/wallet-withdraw.svg",
                  "Saque realizado com sucesso!",
                  () => {
                    this.completedTransfer = false;
                    this.walletKeyComponent += 1;
                    this.$emit("refresh");
                  }
                );
              default:
                this.preloader = false;
                break;
            }
          }
        },
        this
      );
      this.$cable.subscribe(
        { channel: "TransferChannel", room: this.professional.account.id },
        this.channelId
      );
    }
  },

  mounted() {
    if (this.professional.account.id) {
      this.subscribeToChannel();
    }
  }
};
</script>

<template>
  <v-layout v-if="completedTransfer" class="wallet-box">
    <div class="icon-message"><img :src="transferResultImage" /></div>

    <p class="success-message">{{ transferResultMessage }}</p>
  </v-layout>

  <Wallet
    v-else-if="
      professional.account.payment_gateway_account &&
        professional.account.payment_gateway_account.wallet.id
    "
    :preloader="preloader"
    :key="walletKeyComponent"
    :walletId="this.professional.account.payment_gateway_account.wallet.id"
    :withDraw="true"
    :owner="this.professional"
    v-on:requestWithdraw="requestWithDraw"
  />
  <div v-else>
    Carteira do profissional ainda não foi criada.
  </div>
</template>

<style scoped>
.wallet-box {
  min-height: 405px;
  min-width: 205px;
  align-items: center;
  justify-content: center;
}

.success-message {
  color: var(--purple);
}

.icon-message {
  background-color: #fff;
  width: 80px;
  height: 30px;
  margin-top: -15px;
}

.icon-message img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Tabs/Wallet.vue